'use strict';

import {staticUrl} from 'utils/django';

import modalDirective from '../../rest-modal';


export default modalDirective({
	scopedTemplateUrl: templateUrl,
});


function templateUrl(scope) {
	var name = scope.$context.name;
	var version = scope.$context.version;

	if (!name) throw 'This directive requires the form `name` to be defined in the context';
	if (!version) throw 'This directive requires the form `version` to be defined in the context';

	var url = staticUrl(`daupler/incidents/forms/${name}/${version}/create.html`);
	return url;
}
